import { getTechnicianLandingPath } from "./technicianRouting";

export const OPS_MANAGER_ROOT_ROLES = [
  "admin",
  "host",
  "owner",
  "manager",
  "receptionist",
  "solo_technician",
  "reception",
  "independent_professional",
];

export function getOpsAuthenticatedRootPath({
  normalizedRole = "",
  user = null,
  technicianStatus = null,
} = {}) {
  const role = String(normalizedRole || user?.role || "").toLowerCase();
  const hasSelectedSalon =
    technicianStatus?.has_selected_salon ?? Boolean(user?.salon_id);
  const staffSetupComplete = technicianStatus?.staff_setup_complete ?? false;
  const profileComplete = technicianStatus?.profile_complete ?? false;

  if (role === "technician") {
    return getTechnicianLandingPath({
      hasSelectedSalon,
      staffSetupComplete,
      profileComplete,
    });
  }

  if (role === "independent_professional" && !user?.salon_id) {
    return "/setup?mode=independent_professional";
  }

  if (!user?.salon_id) {
    if (user?.is_super_admin) {
      return "/superadmin";
    }
    return "/select-salon";
  }

  return OPS_MANAGER_ROOT_ROLES.includes(role) ? "/manager/schedule" : "/my-bookings";
}
